const addInfo = {
  title: 'ColdChainMonitoring',
  icon: 'cold-chain'
}
// const coldChainMonitoringRouter = {
//   path: '/cold-chain-monitoring',
//   component: () => import('@/views/ColdChainMonitoring/cold-chain-monitoring'),
//   name: 'ColdChainMonitoring',
//   meta: { title: 'ColdChainMonitoring', icon: 'cold-chain', parent: addInfo }
// }
const coldChainMonitoringRouter = {
  path: '/cold-chain-monitoring',
  component: () => import('@/views/report/ColdChain/temperature-report'),
  name: 'ColdChainMonitoring',
  meta: { title: 'ColdChainMonitoring', icon: 'cold-chain', parent: addInfo, permission: ['cold_chain_monitoring'] }
}
export default coldChainMonitoringRouter